import NA from "../Assests/Products/NA.png";
import Vault from "../Assests/Products/Vault.png";

export const productDatapage = [
  {
    img: NA,
    name: "Net Analyzer",
    description:
      "Your privacy-centric network insights app, enhancing connectivity while prioritizing data security.",
    colorCode: "#219FD5",
    link: "na_privacy.html",
  },
  {
    img: Vault,
    name: "Vault",
    description:
      "Your secure data management solution, prioritizing privacy and control for seamless password storage and sharing.",
    colorCode: "#5DB075",
    link: "vault_privacy.html",
  },
];
